var React = require('react');
import PropTypes from 'prop-types';
import createClass from 'create-react-class';
var SettingsAdvertiserComponent = require('../components/settings-advertiser.jsx');

var SettingsAdvertiser = createClass({

  propTypes: {
    currentAccount: PropTypes.object.isRequired
  },

  render() {
    const {currentAccount} = this.props;

    return (
        <SettingsAdvertiserComponent account={currentAccount} />
    );
  }
});

export default SettingsAdvertiser;
